/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Location_LabelInputs */



/**
* | output |
* | --- |
* | "Media Location" |
*
* @param {Media_Import_Location_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_location_label = /** @type {((inputs?: Media_Import_Location_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Location_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Emplacement du media")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienstandort")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione dei media")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Медиа-местоположение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ubicación de los medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアの場所")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया स्थान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Localização da mídia")
	return /** @type {LocalizedString} */ ("Media Location")
});